var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'grammar-theme-' + _vm.theme},[(_vm.entity.title)?_c('div',[_vm._v(_vm._s(_vm.entity.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }